import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { convertUTCTimeToISTTime } from '../../../utils/Utilities';

const BPTable = () => {

    const columns = [
        { 
            id: 'date', 
            label: 'Date', 
            minWidth: 170,
            align:'left'
        },
        { 
            id: 'time', 
            label: 'Time', 
            minWidth: 100,
            align:'left'
        },
        {
            id: 'systolic',
            label: 'Systolic',
            minWidth: 170,
            align:'left'
        },
        {
            id: 'diastolic',
            label: 'Diastolic',
            minWidth: 170,
            align:'left'
        },
        {
            id: 'type',
            label: 'Type',
            minWidth: 170,
            align:'center'
        },
    ];

    // const rows = [
    //     createData('12/10/2023', '12:01:32', "118", "75","normal"),
    //     createData('12/10/2023', '12:01:32', "173", "45.4","elevated"),
    //     createData('12/10/2023', '12:01:32', "173", "45.4","high"),
    //     createData('12/10/2023', '12:01:32', "173", "45.4","normal"),
    //     createData('12/10/2023', '12:01:32', "173", "45.4","normal"),
    //     createData('12/10/2023', '12:01:32', "173", "45.4","normal"),
    //     createData('12/10/2023', '12:01:32', "173", "45.4","normal"),
        
    // ];

    function createData(date, time, systolic, diastolic,type) {
        return { date, time, systolic, diastolic,type };
    }

    //states

    const theme = useTheme();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rows,setRows] = useState([]);

    const {
        pastVitalsData : {data,error,pastVitalsLoader}
    } = useSelector((state) => state.prescription);

    //effects

    useEffect(()=>{
        if(data?.VITALS?.length){
            let dataArray = data?.VITALS?.find(elem=>elem.name=='bp');
            if(dataArray?.values){
                let results = [];
                dataArray?.values?.forEach(row=>{
                    let value = row?.value?.split('/');
                    if(value?.length){
                        results.push(
                            createData(
                                dayjs(row?.date,'YYYY-MM-DD').format('DD/MM/YYYY'),
                                convertUTCTimeToISTTime(row?.time),
                                value[0],
                                value[1],
                                row?.type
                            )
                        )
                    }
                })
                setRows(results);
            }
        }
    },[data])

    //functions

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    
    const getTag = (type) => {
        switch(type){
            case 'hypo':
                return (
                    <Box px={2} py={0.2} sx={{display:'flex',gap:1,justifyContent:'center',alignItems:'center',backgroundColor:'#0048ff1a',borderRadius:'10px'}}>
                        <Box
                            width={'6px'}
                            height={'6px'}
                            sx={{
                                borderRadius:'50%',
                                backgroundColor:'#0048ff80'
                            }}
                        />
                        <Typography variant='caption'>{type[0]?.toUpperCase() + type?.slice(1)}</Typography>
                    </Box>
                )
            case 'normal':
                return (
                    <Box px={2} py={0.2} sx={{display:'flex',gap:1,justifyContent:'center',alignItems:'center',backgroundColor:'#E8FDF3',borderRadius:'10px'}}>
                        <Box
                            width={'6px'}
                            height={'6px'}
                            sx={{
                                borderRadius:'50%',
                                backgroundColor:'#12B76A'
                            }}
                        />
                        <Typography variant='caption'>{type[0]?.toUpperCase() + type?.slice(1)}</Typography>
                    </Box>
                )
            case 'elevated':
                return (
                    <Box px={2} py={0.2} sx={{display:'flex',gap:1,justifyContent:'center',alignItems:'center',backgroundColor:'#FFF0E9',borderRadius:'10px'}}>
                        <Box
                            width={'6px'}
                            height={'6px'}
                            sx={{
                                borderRadius:'50%',
                                backgroundColor:'#FF7A3C'
                            }}
                        />
                        <Typography variant='caption'>{type[0]?.toUpperCase() + type?.slice(1)}</Typography>
                    </Box>
                )
            case 'hyper':
                return (
                    <Box px={2} py={0.2} sx={{display:'flex',gap:1,justifyContent:'center',alignItems:'center',backgroundColor:'#ff9a6c33',borderRadius:'10px'}}>
                        <Box
                            width={'6px'}
                            height={'6px'}
                            sx={{
                                borderRadius:'50%',
                                backgroundColor:'#FF9A6C'
                            }}
                        />
                        <Typography variant='caption'>{type[0]?.toUpperCase() + type?.slice(1)}</Typography>
                    </Box>
                )
            case 'crisis':
                return (
                    <Box px={2} py={0.2} sx={{display:'flex',gap:1,justifyContent:'center',alignItems:'center',backgroundColor:'#FFE7E7',borderRadius:'10px'}}>
                        <Box
                            width={'6px'}
                            height={'6px'}
                            sx={{
                                borderRadius:'50%',
                                backgroundColor:'#FB1D20'
                            }}
                        />
                        <Typography variant='caption'>{type[0]?.toUpperCase() + type?.slice(1)}</Typography>
                    </Box>
                )
        }
    }


    return (
        <Paper sx={{ width: '100%',height:'100%'}}>
            <TableContainer sx={{height:'100%'}}>
                <Table stickyHeader aria-label="sticky table" sx={{height:'fit-content' ,overflowY:'auto'}}>
                    <TableHead >
                        <TableRow>
                        {columns.map((column) => (
                            <TableCell
                            key={column.id}
                            align={column.align}
                            // style={{ minWidth: column.minWidth }}
                            sx={{backgroundColor:theme.palette.blue.light}}
                            >
                            {column.label}
                            </TableCell>
                        ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                    const value = row[column.id];

                                    if(column.id ==='type'){
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {getTag(value)}
                                            </TableCell>
                                        )
                                    }
                                    return (
                                        <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === 'number'
                                            ? column.format(value)
                                            : value}
                                        </TableCell>
                                    );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                {/* <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                        minWidth:"100%",
                        width:"100%"
                    }}
                /> */}
                </TableContainer>
            
            
        </Paper>
    )
}

export default BPTable